import NotImmplemented from "./NotImplemented"
import "../App.css"

const Share = () => {
  return (
    <div className="modalContainer">
      <h3>Share</h3>
      <NotImmplemented />
    </div>
  )
}

export default Share
